// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LAKPED-7 — Alta de pedido desde documento escaneado.
   Acotado a .scan-container: el CSS de CRA es global. */
.scan-container {
  padding: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.scan-container .scan-back {
  border: none;
  background: transparent;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  padding: 0 0 14px;
}

.scan-container .scan-back:hover { color: var(--button-color); }

.scan-title {
  font-size: 23px;
  font-weight: 600;
  color: #000;
  margin: 0 0 24px;
}

.scan-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 260px;
  padding: 32px;
  border: 2px dashed #d9d9d9;
  border-radius: 12px;
  background: #fff;
  color: #9a9a9a;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.scan-dropzone:hover,
.scan-dropzone.drag-over {
  border-color: var(--button-color);
  color: var(--button-color);
  background: #fafafa;
}

.scan-dropzone.reading { cursor: default; border-style: solid; }

.scan-dropzone-text { font-size: 16px; color: #333; margin: 6px 0 0; }
.scan-dropzone-hint { font-size: 13px; color: #9a9a9a; margin: 0; }

.scan-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #e8e8e8;
  border-top-color: var(--button-color);
  border-radius: 50%;
  animation: scan-spin 0.9s linear infinite;
}

@keyframes scan-spin { to { transform: rotate(360deg); } }



.scan-container .scan-change {
  margin-left: auto;
  border: none;
  background: transparent;
  color: var(--button-color);
  font-size: 13px;
  cursor: pointer;
}

.scan-container .scan-change:hover { text-decoration: underline; }

.scan-warning {
  padding: 11px 16px;
  margin-bottom: 18px;
  border-radius: 8px;
  background: #fff8e6;
  border: 1px solid #f0e2bd;
  color: #6b5412;
  font-size: 13px;
}

.scan-error {
  padding: 12px 16px;
  margin-bottom: 18px;
  border-radius: 8px;
  background: #fee2e2;
  color: #991b1b;
  font-size: 14px;
}

.scan-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 14px;
}

.scan-field { display: flex; flex-direction: column; gap: 5px; }

.scan-field label {
  font-size: 12px;
  color: #666;
}

.scan-container .scan-field input,
.scan-container .scan-field textarea {
  padding: 9px 11px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  color: #000;
  font-family: inherit;
  background: #fff;
  resize: vertical;
}

.scan-container .scan-field input:focus,
.scan-container .scan-field textarea:focus {
  outline: none;
  border-color: var(--button-color);
}

.scan-container .scan-field input::placeholder { color: #c4c4c4; font-style: italic; }

.scan-analyze {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 16px;
  padding: 13px 16px;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 10px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.scan-analyze input { margin-top: 2px; accent-color: var(--button-color); cursor: pointer; }
.scan-analyze-hint { display: block; font-size: 12px; color: #999; margin-top: 2px; }

.scan-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 22px;
}

.scan-container .scan-cancel,
.scan-container .scan-confirm {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.15s ease, border-color 0.15s ease;
}

.scan-container .scan-cancel {
  border: 1px solid #d5d5d5;
  background: #fff;
  color: #555;
}

.scan-container .scan-cancel:hover:not(:disabled) { border-color: #b5b5b5; }

.scan-container .scan-confirm {
  border: 1px solid transparent;
  background: var(--button-color);
  color: #fff;
}

.scan-container .scan-confirm:hover:not(:disabled) { opacity: 0.9; }
.scan-container .scan-confirm:disabled,
.scan-container .scan-cancel:disabled { opacity: 0.55; cursor: not-allowed; }


/* ───────── LAKPED-16.5: revisión del pedido con sus líneas y su oferta ───────── */

.scan-pasos {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
}

.scan-pasos li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #888;
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 20px;
  padding: 5px 14px 5px 6px;
}

.scan-paso-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #e5e5e5;
  color: #555;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

.scan-pasos li.hecho { color: #333; }
.scan-pasos li.hecho .scan-paso-num { background: #1a9b5a; color: #fff; }
.scan-pasos li.actual { color: #111; border-color: #111; font-weight: 600; }
.scan-pasos li.actual .scan-paso-num { background: #111; color: #fff; }

.scan-sub { font-size: 13.5px; color: #777; margin: 0 0 20px; }

/* Documento a la izquierda, lo que se revisa a la derecha */
.scan-columnas {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 16px;
  align-items: start;
}

.scan-doc {
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  overflow: hidden;
}

.scan-doc img { width: 100%; display: block; }
.scan-doc-vacio { padding: 60px 16px; text-align: center; color: #999; font-size: 13px; }

.scan-doc-pie {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 12px;
  color: #777;
  padding: 8px 12px;
  border-top: 1px solid #eee;
}

.scan-tarjeta {
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 16px;
}

.scan-tarjeta h2 { font-size: 15px; font-weight: 600; margin: 0 0 12px; color: #1b1b1b; }
.scan-tarjeta.sugerida { border-color: #1a9b5a; }
.scan-tarjeta.vinculada { border-color: #1a9b5a; background: #f6fcf8; }

/* Lo que ha leído la IA va en azul, igual que en la pantalla de clasificación */
.scan-badge {
  font-style: normal;
  font-size: 10.5px;
  font-weight: 600;
  color: #2563b0;
  background: #e8f1fc;
  border-radius: 10px;
  padding: 1px 7px;
  margin-left: 6px;
  vertical-align: middle;
}

.scan-container .scan-field.detectado input { background: #f0f7ff; border-color: #9cc3f0; }

/* Líneas */
.scan-lineas { width: 100%; border-collapse: collapse; }
.scan-lineas th {
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  padding: 6px 8px;
  border-bottom: 1px solid #eee;
}
.scan-lineas td { padding: 6px 8px; border-bottom: 1px solid #f4f4f4; font-size: 14px; }
.scan-lineas th.der, .scan-lineas td.der { text-align: right; }

.scan-container .scan-lineas input {
  font: inherit;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 6px 8px;
  width: 100%;
  box-sizing: border-box;
}

.scan-container .scan-lineas input.corto { max-width: 110px; text-align: right; }
.scan-ofertado { color: #157347; font-weight: 500; }
.scan-muted { color: #999; font-weight: 400; }

.scan-chip {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  border-radius: 10px;
  padding: 2px 8px;
  background: #dff5e8;
  color: #157347;
  white-space: nowrap;
}

.scan-chip.naranja { background: #fff0e3; color: #8a4b00; }

.scan-container .scan-quitar {
  border: none;
  background: none;
  color: #999;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
  margin-left: 6px;
}

.scan-container .scan-quitar:hover { color: #b71c1c; }

.scan-container .scan-anadir {
  border: 1px dashed #c8c8c8;
  background: #fff;
  border-radius: 8px;
  padding: 7px 14px;
  font: inherit;
  font-size: 13px;
  color: #444;
  cursor: pointer;
  margin-top: 12px;
}

.scan-container .scan-anadir:hover { border-color: #111; color: #111; }

.scan-ayuda { font-size: 12.5px; color: #888; margin: 10px 0 0; }

/* Oferta relacionada */
.scan-oferta-fila {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  font-size: 13.5px;
}

.scan-oferta-fila p { margin: 4px 0 0; font-size: 12.5px; }
.scan-oferta-acciones { display: flex; gap: 8px; }

.scan-container .scan-secundario,
.scan-container .scan-principal {
  border-radius: 8px;
  padding: 7px 14px;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
}

.scan-container .scan-secundario { background: #fff; border: 1px solid #bbb; color: #111; }
.scan-container .scan-secundario:hover { background: #eee; }
.scan-container .scan-principal { background: #111; border: 1px solid #111; color: #fff; }
.scan-container .scan-principal:hover { background: #333; }

@media (max-width: 900px) {
  .scan-columnas { grid-template-columns: 1fr; }
  .scan-tarjeta { overflow-x: auto; }
}

@media (max-width: 760px) {
  .scan-container { padding: 20px 16px; }
  .scan-actions { flex-direction: column-reverse; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrderScanPage.css"],"names":[],"mappings":"AAAA;wDACwD;AACxD;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA,mCAAmC,0BAA0B,EAAE;;AAE/D;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,yBAAyB,eAAe,EAAE,mBAAmB,EAAE;;AAE/D,sBAAsB,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE;AACrE,sBAAsB,eAAe,EAAE,cAAc,EAAE,SAAS,EAAE;;AAElE;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,uBAAuB,KAAK,yBAAyB,EAAE,EAAE;;;;AAIzD;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA,qCAAqC,0BAA0B,EAAE;;AAEjE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,cAAc,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAE/D;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,iCAAiC;AACnC;;AAEA,iDAAiD,cAAc,EAAE,kBAAkB,EAAE;;AAErF;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB,eAAe,EAAE,iCAAiC,EAAE,eAAe,EAAE;AAC3F,qBAAqB,cAAc,EAAE,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE;;AAEpF;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA,oDAAoD,qBAAqB,EAAE;;AAE3E;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;;AAEA,qDAAqD,YAAY,EAAE;AACnE;wCACwC,aAAa,EAAE,mBAAmB,EAAE;;;AAG5E,oFAAoF;;AAEpF;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB,WAAW,EAAE;AACpC,sCAAsC,mBAAmB,EAAE,WAAW,EAAE;AACxE,wBAAwB,WAAW,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC3E,uCAAuC,gBAAgB,EAAE,WAAW,EAAE;;AAEtE,YAAY,iBAAiB,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAE9D,4DAA4D;AAC5D;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gBAAgB,WAAW,EAAE,cAAc,EAAE;AAC7C,kBAAkB,kBAAkB,EAAE,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE;;AAExF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACxF,yBAAyB,qBAAqB,EAAE;AAChD,0BAA0B,qBAAqB,EAAE,mBAAmB,EAAE;;AAEtE,gFAAgF;AAChF;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,8CAA8C,mBAAmB,EAAE,qBAAqB,EAAE;;AAE1F,WAAW;AACX,eAAe,WAAW,EAAE,yBAAyB,EAAE;AACvD;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;AACA,kBAAkB,gBAAgB,EAAE,gCAAgC,EAAE,eAAe,EAAE;AACvF,2CAA2C,iBAAiB,EAAE;;AAE9D;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA,2CAA2C,gBAAgB,EAAE,iBAAiB,EAAE;AAChF,iBAAiB,cAAc,EAAE,gBAAgB,EAAE;AACnD,cAAc,WAAW,EAAE,gBAAgB,EAAE;;AAE7C;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,qCAAqC,cAAc,EAAE;;AAErD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,qCAAqC,kBAAkB,EAAE,WAAW,EAAE;;AAEtE,cAAc,iBAAiB,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAEhE,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,sBAAsB,eAAe,EAAE,iBAAiB,EAAE;AAC1D,wBAAwB,aAAa,EAAE,QAAQ,EAAE;;AAEjD;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA,mCAAmC,gBAAgB,EAAE,sBAAsB,EAAE,WAAW,EAAE;AAC1F,yCAAyC,gBAAgB,EAAE;AAC3D,kCAAkC,gBAAgB,EAAE,sBAAsB,EAAE,WAAW,EAAE;AACzF,wCAAwC,gBAAgB,EAAE;;AAE1D;EACE,iBAAiB,0BAA0B,EAAE;EAC7C,gBAAgB,gBAAgB,EAAE;AACpC;;AAEA;EACE,kBAAkB,kBAAkB,EAAE;EACtC,gBAAgB,8BAA8B,EAAE;AAClD","sourcesContent":["/* LAKPED-7 — Alta de pedido desde documento escaneado.\n   Acotado a .scan-container: el CSS de CRA es global. */\n.scan-container {\n  padding: 40px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.scan-container .scan-back {\n  border: none;\n  background: transparent;\n  color: #666;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0 0 14px;\n}\n\n.scan-container .scan-back:hover { color: var(--button-color); }\n\n.scan-title {\n  font-size: 23px;\n  font-weight: 600;\n  color: #000;\n  margin: 0 0 24px;\n}\n\n.scan-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 260px;\n  padding: 32px;\n  border: 2px dashed #d9d9d9;\n  border-radius: 12px;\n  background: #fff;\n  color: #9a9a9a;\n  cursor: pointer;\n  text-align: center;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n}\n\n.scan-dropzone:hover,\n.scan-dropzone.drag-over {\n  border-color: var(--button-color);\n  color: var(--button-color);\n  background: #fafafa;\n}\n\n.scan-dropzone.reading { cursor: default; border-style: solid; }\n\n.scan-dropzone-text { font-size: 16px; color: #333; margin: 6px 0 0; }\n.scan-dropzone-hint { font-size: 13px; color: #9a9a9a; margin: 0; }\n\n.scan-spinner {\n  width: 30px;\n  height: 30px;\n  border: 3px solid #e8e8e8;\n  border-top-color: var(--button-color);\n  border-radius: 50%;\n  animation: scan-spin 0.9s linear infinite;\n}\n\n@keyframes scan-spin { to { transform: rotate(360deg); } }\n\n\n\n.scan-container .scan-change {\n  margin-left: auto;\n  border: none;\n  background: transparent;\n  color: var(--button-color);\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.scan-container .scan-change:hover { text-decoration: underline; }\n\n.scan-warning {\n  padding: 11px 16px;\n  margin-bottom: 18px;\n  border-radius: 8px;\n  background: #fff8e6;\n  border: 1px solid #f0e2bd;\n  color: #6b5412;\n  font-size: 13px;\n}\n\n.scan-error {\n  padding: 12px 16px;\n  margin-bottom: 18px;\n  border-radius: 8px;\n  background: #fee2e2;\n  color: #991b1b;\n  font-size: 14px;\n}\n\n.scan-form {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 14px;\n}\n\n.scan-field { display: flex; flex-direction: column; gap: 5px; }\n\n.scan-field label {\n  font-size: 12px;\n  color: #666;\n}\n\n.scan-container .scan-field input,\n.scan-container .scan-field textarea {\n  padding: 9px 11px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #000;\n  font-family: inherit;\n  background: #fff;\n  resize: vertical;\n}\n\n.scan-container .scan-field input:focus,\n.scan-container .scan-field textarea:focus {\n  outline: none;\n  border-color: var(--button-color);\n}\n\n.scan-container .scan-field input::placeholder { color: #c4c4c4; font-style: italic; }\n\n.scan-analyze {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 16px;\n  padding: 13px 16px;\n  background: #fff;\n  border: 1px solid #ececec;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n}\n\n.scan-analyze input { margin-top: 2px; accent-color: var(--button-color); cursor: pointer; }\n.scan-analyze-hint { display: block; font-size: 12px; color: #999; margin-top: 2px; }\n\n.scan-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 22px;\n}\n\n.scan-container .scan-cancel,\n.scan-container .scan-confirm {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity 0.15s ease, border-color 0.15s ease;\n}\n\n.scan-container .scan-cancel {\n  border: 1px solid #d5d5d5;\n  background: #fff;\n  color: #555;\n}\n\n.scan-container .scan-cancel:hover:not(:disabled) { border-color: #b5b5b5; }\n\n.scan-container .scan-confirm {\n  border: 1px solid transparent;\n  background: var(--button-color);\n  color: #fff;\n}\n\n.scan-container .scan-confirm:hover:not(:disabled) { opacity: 0.9; }\n.scan-container .scan-confirm:disabled,\n.scan-container .scan-cancel:disabled { opacity: 0.55; cursor: not-allowed; }\n\n\n/* ───────── LAKPED-16.5: revisión del pedido con sus líneas y su oferta ───────── */\n\n.scan-pasos {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  list-style: none;\n  margin: 0 0 20px;\n  padding: 0;\n}\n\n.scan-pasos li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #888;\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 20px;\n  padding: 5px 14px 5px 6px;\n}\n\n.scan-paso-num {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #e5e5e5;\n  color: #555;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.scan-pasos li.hecho { color: #333; }\n.scan-pasos li.hecho .scan-paso-num { background: #1a9b5a; color: #fff; }\n.scan-pasos li.actual { color: #111; border-color: #111; font-weight: 600; }\n.scan-pasos li.actual .scan-paso-num { background: #111; color: #fff; }\n\n.scan-sub { font-size: 13.5px; color: #777; margin: 0 0 20px; }\n\n/* Documento a la izquierda, lo que se revisa a la derecha */\n.scan-columnas {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 16px;\n  align-items: start;\n}\n\n.scan-doc {\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.scan-doc img { width: 100%; display: block; }\n.scan-doc-vacio { padding: 60px 16px; text-align: center; color: #999; font-size: 13px; }\n\n.scan-doc-pie {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  font-size: 12px;\n  color: #777;\n  padding: 8px 12px;\n  border-top: 1px solid #eee;\n}\n\n.scan-tarjeta {\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  padding: 18px 20px;\n  margin-bottom: 16px;\n}\n\n.scan-tarjeta h2 { font-size: 15px; font-weight: 600; margin: 0 0 12px; color: #1b1b1b; }\n.scan-tarjeta.sugerida { border-color: #1a9b5a; }\n.scan-tarjeta.vinculada { border-color: #1a9b5a; background: #f6fcf8; }\n\n/* Lo que ha leído la IA va en azul, igual que en la pantalla de clasificación */\n.scan-badge {\n  font-style: normal;\n  font-size: 10.5px;\n  font-weight: 600;\n  color: #2563b0;\n  background: #e8f1fc;\n  border-radius: 10px;\n  padding: 1px 7px;\n  margin-left: 6px;\n  vertical-align: middle;\n}\n\n.scan-container .scan-field.detectado input { background: #f0f7ff; border-color: #9cc3f0; }\n\n/* Líneas */\n.scan-lineas { width: 100%; border-collapse: collapse; }\n.scan-lineas th {\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  padding: 6px 8px;\n  border-bottom: 1px solid #eee;\n}\n.scan-lineas td { padding: 6px 8px; border-bottom: 1px solid #f4f4f4; font-size: 14px; }\n.scan-lineas th.der, .scan-lineas td.der { text-align: right; }\n\n.scan-container .scan-lineas input {\n  font: inherit;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 6px 8px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.scan-container .scan-lineas input.corto { max-width: 110px; text-align: right; }\n.scan-ofertado { color: #157347; font-weight: 500; }\n.scan-muted { color: #999; font-weight: 400; }\n\n.scan-chip {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 10px;\n  padding: 2px 8px;\n  background: #dff5e8;\n  color: #157347;\n  white-space: nowrap;\n}\n\n.scan-chip.naranja { background: #fff0e3; color: #8a4b00; }\n\n.scan-container .scan-quitar {\n  border: none;\n  background: none;\n  color: #999;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 4px;\n  margin-left: 6px;\n}\n\n.scan-container .scan-quitar:hover { color: #b71c1c; }\n\n.scan-container .scan-anadir {\n  border: 1px dashed #c8c8c8;\n  background: #fff;\n  border-radius: 8px;\n  padding: 7px 14px;\n  font: inherit;\n  font-size: 13px;\n  color: #444;\n  cursor: pointer;\n  margin-top: 12px;\n}\n\n.scan-container .scan-anadir:hover { border-color: #111; color: #111; }\n\n.scan-ayuda { font-size: 12.5px; color: #888; margin: 10px 0 0; }\n\n/* Oferta relacionada */\n.scan-oferta-fila {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13.5px;\n}\n\n.scan-oferta-fila p { margin: 4px 0 0; font-size: 12.5px; }\n.scan-oferta-acciones { display: flex; gap: 8px; }\n\n.scan-container .scan-secundario,\n.scan-container .scan-principal {\n  border-radius: 8px;\n  padding: 7px 14px;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.scan-container .scan-secundario { background: #fff; border: 1px solid #bbb; color: #111; }\n.scan-container .scan-secundario:hover { background: #eee; }\n.scan-container .scan-principal { background: #111; border: 1px solid #111; color: #fff; }\n.scan-container .scan-principal:hover { background: #333; }\n\n@media (max-width: 900px) {\n  .scan-columnas { grid-template-columns: 1fr; }\n  .scan-tarjeta { overflow-x: auto; }\n}\n\n@media (max-width: 760px) {\n  .scan-container { padding: 20px 16px; }\n  .scan-actions { flex-direction: column-reverse; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
